export default "__VITE_ASSET__BjLjcjv2__"